import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import {App} from './components';
import {BASE_URL, KP, WS_STR} from './settings';
import appParams from '../params.json';
import configureStore from './lib/redux/store/configureStore';

let initialParams = {};

Object.keys(appParams).map(key => {
    initialParams[key] = {
        cleaned: 0,
        value: '?',
        disabled: true,
        firstload: true
    };
    return null;
});

const store = configureStore(
    {params: initialParams}
);

render(
    <Provider store={store}>
        <App base_url={BASE_URL} kp={KP} ws_str={WS_STR}/>
    </Provider>,
    document.getElementById('scadamainapp'),
);



// WEBPACK FOOTER //
// ./src/index.js